import React, { useEffect, useState } from "react";
import {
  TextField,
  ReferenceManyField,
  Datagrid,
  Pagination,
  useDataProvider,
  ReferenceField,
  NumberField,
  FunctionField,
} from "react-admin";
import { useClientContext } from "contexts/client";
import { Typography } from '@mui/material';

export default function AdminMasterStoreTab() {
  const dataProvider = useDataProvider();
  const { state: clientContext } = useClientContext();
  const [ authSuppliers, setAuthSuppliers ] = useState([]);
  useEffect(() => {
    if (authSuppliers.length === 0) {
      dataProvider
        .getList(`${clientContext.client.CLIENT_NAME}_authorized_suppliers`, {
          filter: {},
          sort: { order: "desc", field: "warehouse_id" },
          pagination: { page: 1, perPage: 1000 },
        })
        .then((response) => {
          if (response?.data) {
            setAuthSuppliers(response.data.map((item) => item.warehouse_id));
          }
        });
    }

    return () => {};
  }, [clientContext.client.CLIENT_NAME, dataProvider, authSuppliers]);

  return (
    <>
      <Typography variant="h6" gutterBottom>Data Suppliers</Typography>
      <ReferenceManyField
        fullWidth
        label="Fact Summary Detail"
        reference={`${clientContext.client.CLIENT_NAME}_fact_stores`}
        target="master_store_id"
        source="id"
        perPage={10}
        sort={{ field: "id", order: "DESC" }}
        pagination={<Pagination />}
      >
        <Datagrid>
          <ReferenceField
            reference="data_suppliers"
            source="warehouse_id"
            link={false}
            sortable={false}
          >
            <TextField source="warehouse_name" />
          </ReferenceField>
          <FunctionField
            label="Earliest Reported"
            render={(record) =>
              `Week ${record.earliest_reported.substring(
                4,
                6
              )} - ${record.earliest_reported.substring(0, 4)}`
            }
          />
          <FunctionField
            label="Last Reported"
            render={(record) =>
              `Week ${record?.last_reported
                ?.toString()
                .substring(4, 6)} - ${record?.last_reported
                ?.toString()
                .substring(0, 4)}`
            }
          />

          <NumberField
            source="total_dollars"
            options={{ style: "currency", currency: "USD" }}
          />
        </Datagrid>
      </ReferenceManyField>

      <Typography variant="h6" gutterBottom>Cross References</Typography>
      <ReferenceManyField
        fullWidth
        label="InfoBate Cross References"
        reference="import_customer"
        target="master_store_id"
        source="id"
        perPage={10}
        sort={{ field: "id", order: "DESC" }}
        pagination={<Pagination />}
        // filter={{
        //   'warehouse_id': authSuppliers,
        // }}
      >
        <Datagrid>
          <TextField label="Xref ID" source="id" />
          <TextField source="chain_num" />
          <TextField source="customer_num" />
          <TextField source="customer_name" />
          <TextField source="address_1" />
          <TextField source="city" />
          <TextField source="state" />
          <TextField source="zip" />
          <TextField source="repname" />
          <TextField source="warehouse_name" />
        </Datagrid>
      </ReferenceManyField>

      <Typography variant="h6" gutterBottom>Master Store History</Typography>
      <ReferenceManyField
        fullWidth
        label="Master Store History"
        reference="master_customer_history"
        target="master_store_id"
        perPage={10}
        sort={{ field: "event_id", order: "DESC" }}
        pagination={<Pagination />}
      >
        <Datagrid>
          <TextField label="Event ID" source="event_id" />
          <TextField source="action_tstamp_clk" />
          <FunctionField source="changed_fields" label="Changed Fields" render={d => JSON.stringify(d.changed_fields, null, 2)} />
          <FunctionField source="row_data" label="Row Data" render={d => JSON.stringify(d.row_data, null, 2)} />
        </Datagrid>
      </ReferenceManyField>
    </>
  );
}
